import { PerspectiveCamera } from '@react-three/drei';

const Camera = (props) => {
  const { camera } = props;

  return (
    <PerspectiveCamera
      makeDefault
      ref={camera}
      position={[0, 8, 8]}
      near={0.1}
      far={1000000}
      rotation={[Math.PI * -0.2, 0, 0]}
    >
    </PerspectiveCamera>
  )
}

export default Camera;